import { TransactionParameters } from "../view-models/TransactionParameters";
import { useSessionStore } from "../../../state/src/useSessionStore";

export const buildTransactionParametersFromStore = (validationResponse: any, transactionType: string): TransactionParameters => {
	const s = (useSessionStore as any).getState?.() || {};
	const readyToCommit: boolean = validationResponse?.ReadyForCommit;

	const params = new TransactionParameters();
	params.transactionType = transactionType;
	params.transactionStatus = readyToCommit ? 'Completed' : 'Failed';
	params.senderName = [s.senderFirstName, s.senderMiddleName, s.senderLastName, s.senderLastName2]
		.filter((x: string | null | undefined) => !!x && String(x).trim().length)
		.join(' ');
	params.receiverName = [s.receiverFirstName, s.receiverMiddleName, s.receiverLastName, s.receiverLastName2]
		.filter((x: string | null | undefined) => !!x && String(x).trim().length)
		.join(' ');
	params.agentId = s.agentId || undefined;
	params.kioskId = s.kioskId || undefined;
	params.locationName = s.locationName || undefined;
    params.lastScreenViewed = 'finalReview';
	params.amount = (() => {
		const a = s.currentSendAmount;
		if (typeof a === 'string') {
			const n = Number(a.replace(/,/g, ''));
			return isFinite(n) ? n : undefined;
		}
		return typeof a === 'number' ? a : undefined;
	})();
	params.moneyGramTransactionNumber = validationResponse.MgiTransactionSessionId || undefined;
	// Optional: language setting
	params.language = 'ENG';
	params.startTime = new Date().toISOString();
	params.endTime = new Date().toISOString();
    params.screenDurations = s.recordedScreenDurations || undefined;

	return params;
};
